"use strict";

/**
 * @namespace
 */
gc.gis.module = gc.gis.module || {};

/**
 * Interface zum einklinken in spezielle Teile des Moduls.
 *
 * @typedef gc.gis.module.GCModuleHook
 * @type {Object}
 * @property {function} initFunc Wird beim Initialisieren aufgerufen. Parameter
 *   und Rückgabewert müssen vom jeweiligen Modul behandelt werden.
 * @property {Object} initFunc.options Aufrufoptionen
 * @property {function} [destroyFunc=undefined] Optionale Funktion, die beim
 *   Zerstören aufgerufen werden. Parameter und Rückgabewert müssen vom
 *   jeweiligen Modul behandelt werden.
 * @property {Object} destroyFunc.options Aufrufoptionen
 */

/**
 * @classdesc
 * Basisklasse für GIS-Module.
 *
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Optionen
 * @param {string} [options.label=null] Bezeichnung
 * @param {string} [options.alias=undefined] Eindeutiger Alias für {@link gc.gis.GCApplication#modules|Modulregistry}
 * @param {string} [options.target] HTML-ID des Kontainerelements
 */
gc.gis.module.GCAbstractModule = function(options )
{
	gc.gis.GCObservable.call( this );

	this.label   = options.label || null;
	this.alias   = options.alias;
	this.target  = options.target;
	this.element = null;
	this._hooks  = {};
};
gc.gis.module.GCAbstractModule.prototype = Object.create( gc.gis.GCObservable.prototype );

/**
 * Gibt das Container-Element der UI dieses Moduls zurück.
 *
 * @deprecated FIXME: Muss überarbeitet werden: es kann mehrere Elemente geben
 * @return {jQuery} jQuery-Element
 */
gc.gis.module.GCAbstractModule.prototype.getElement = function()
{
	return this.element;
};

/**
 * Gibt den Alias dieser Modulinstanz zurück.
 *
 * @return {string} Modulalias
 */
gc.gis.module.GCAbstractModule.prototype.getAlias = function()
{
	return this.alias;
};

/**
 * Gibt die Bezeichnung dieser Modulinstanz zurück.
 *
 * @return {string} Bezeichnung dieser Modulinstanz
 */
gc.gis.module.GCAbstractModule.prototype.getLabel = function()
{
	return this.label;
};

/**
 * Mittels Schlüsselwert in ein Modul einklinken. Wird von der implementierenden
 * Klasse verarbeitet.
 *
 * @param {string} key
 * @param {gc.gis.module.GCModuleHook} hook
 */
gc.gis.module.GCAbstractModule.prototype.registerHook = function(key, hook )
{
	if( !this._hooks[key] )
	{
		this._hooks[key] = [];
	}
	this._hooks[key].push( hook );
};

/**
 * Gibt die aktuellen Einklinkungen des Moduls zurück.
 *
 * @param {string} key
 * @return {gc.gis.module.GCModuleHook[]|undefined}
 */
gc.gis.module.GCAbstractModule.prototype.getHooks = function(key )
{
	return this._hooks[key];
};
